import React from 'react';

const BtnFooter = () =>
  <div>
    <div className="success">
      <a
        className="btn btn-lg btn-success"
        href="//manage.auth0.com/#/account/billing/subscription"
      >
        SEE MORE PRICING INFO
      </a>
    </div>
    <div className="default">
      <a className="btn btn-lg btn-default open-contact-form-modal">Talk to sales</a>
    </div>
  </div>;

export default BtnFooter;



// WEBPACK FOOTER //
// ./src/components/pricingPlans/components/BtnFooter.js